import {RowType} from "./RowType";

export function getClassName(rowType, colKey) {
    const classNames = [];

    switch (rowType) {
        case RowType.heading:
            classNames.push('report-heading-col');
            break;
        case RowType.category_total:
            classNames.push('report-category-total-col');
            break;
        case RowType.type_total:
            classNames.push('report-type-total-col');
            break;
        case RowType.spacer:
            classNames.push('report-spacer-col');
            break;
        default:
            classNames.push('report-normal-col');
            break;
    }

    classNames.push(`report-${colKey}-cell`);

    return classNames.join(' ');
}
